import React, { useEffect } from "react";
import {
  TextField,
  Box,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Dialog,
  Divider,
  Grid,
  FormLabel,
  Button,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import Titulo from "../Titulo";
import ModalConfirm from "../ModalConfirm";
import Alert from "../Alert";
import { getValidaCNPJ } from "../../helper/checkCNPJ";
import { formatDocument, normalizeDocument } from "../../helper/document";

const statusOption = [
  {
    key: 1,
    value: true,
    label: "Ativa",
  },
  {
    key: 2,
    value: false,
    label: "Inativa",
  },
];

const tamanhoForm = {
  width: "100%",
};

function ModalCadastroEdicao({
  open,
  handleClose,
  actionSave,
  acquirer,
  actionEdit,
}) {
  const [precadastro, setPreCadastro] = React.useState(null);
  const [nomeFantasia, setNomeFantasia] = React.useState(null);
  const [cnpj, setCNPJ] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [interno, setInterno] = React.useState(null);
  const [externo, setExterno] = React.useState(null);
  const [files, setFiles] = React.useState(null);
  const [sigla, setSigla] = React.useState(null);
  const [disabled, setDisabled] = React.useState(false);
  const [controllerConfirm, setController] = React.useState(false);
  const [mensagem, setMensagemConfirm] = React.useState("");
  const [validation, setValidation] = React.useState(null);

  useEffect(() => {
    if (acquirer && acquirer.Id > 0) {
      setPreCadastro(acquirer.ExigePreCadastro);
      setNomeFantasia(acquirer.NomeFantasia);
      setCNPJ(acquirer.Inscricao);
      setStatus(acquirer.Ativo);
      setInterno(acquirer.PossuiCheckoutInterno);
      setExterno(acquirer.PossuiCheckoutExterno);
      setFiles(acquirer.Logotipo);
      setSigla(acquirer.Sigla);
      setDisabled(true);
      setMensagemConfirm("Tem certeza que deseja atualizar o adquirente?");
    }
  }, [acquirer]);

  const uploadImage = async (e) => {
    var file = e[0];
    if (e.length > 0) {
      const base64 = await convertBase64(file);
      setFiles(base64);
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleChange = (event) => {
    setPreCadastro(event.target.checked);
  };

  const handleChangeNomeFantasia = (event) => {
    setNomeFantasia(event.target.value);
  };

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleChangeInterno = (event) => {
    setInterno(event.target.checked);
  };

  const handleChangeExterno = (event) => {
    setExterno(event.target.checked);
  };

  const save = () => {
    const obje = {
      id: acquirer.Id,
      nomeFantasia: nomeFantasia,
      cnpj: normalizeDocument(cnpj),
      interno: interno,
      externo: externo,
      precadastro: precadastro,
      status: status,
      logo: files,
      sigla: sigla,
    }; 
    
    actionEdit(obje);
  };

  const validateConfirm = (confirm) => {
    if (confirm) {
      save();
      setController(false);
    }
      else
       setController(false);
}

  const cancelar = () => {
    setPreCadastro(null);
    setNomeFantasia(null);
    setCNPJ(null);
    setStatus(null);
    setInterno(null);
    setExterno(null);
    setFiles(null);
    setSigla(null);
    setDisabled(false);
    handleClose();
  };

  const confirma = () => {
    var mensagem = "";
    if (nomeFantasia === null) mensagem += "Nome Fantasia é obrigatório. \n";
    if (cnpj === null) mensagem += "CNPJ é obrigatório. \n";
    if (status === null) mensagem += "Status é obrigatório. \n";
    if (files === null) mensagem += "Logotipo é obrigatório. \n";

    if (mensagem !== "") {
      setValidation(mensagem);
    } else {
      setController(true);
    }
  };

  const validaCnpj = async (e) =>  {
    const cnpj = normalizeDocument(e.target.value);
    if(cnpj.length === 14)
      {
        var retorno = await getValidaCNPJ(cnpj);
        if(retorno && retorno.validate === false)
        {
          setValidation(retorno.mensagem);
          setCNPJ(cnpj);
        }
      }

  }

  return (
    <Dialog
      open={open}
      onClose={cancelar}
      maxWidth="lg"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box component="form" padding={4} noValidate autoComplete="off">
        <Titulo type="small">Cadastro de Adquirentes</Titulo>
        <Divider />
        <Grid container spacing={2}>
          <Grid item md={6}>
            <TextField
              disabled={disabled}
              required
              style={tamanhoForm}
              id="nomeFantasia"
              label="Nome Fantasia"
              defaultValue={nomeFantasia}
              onChange={(e) => handleChangeNomeFantasia(e)}
            />
          </Grid>
          <Grid item md={6}>
            <TextField
              style={tamanhoForm}
              label="CNPJ"
              required
              value={formatDocument(cnpj)}
              onBlur={(e) => validaCnpj(e)}
              onChange={(e) => setCNPJ(normalizeDocument(e.target.value))}
              id="cnpj"
              disabled={disabled}
              name="cnpj"
              type="text"
              inputProps={{ maxLength: 18 }}
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          <Grid item md={6}>
            <FormLabel style={tamanhoForm} id="logotipo" required>
              Logotipo
            </FormLabel>
            {disabled ? (
              <div>
                <img alt="logotipo" src={files} style={{ height: "189px" }} />
              </div>
            ) : (
              <DropzoneArea
                disableRejectionFeedback={disabled}
                filesLimit={1}
                showAlerts={false}
                initialFiles={[files]}
                onChange={(e) => uploadImage(e)}
                clearOnUnmount={true}
              />
            )}
          </Grid>
          <Grid item md={6}>
            <Grid container spacing={2}>
              <Grid item md={12}>
                <TextField
                  disabled
                  style={tamanhoForm}
                  id="sigla"
                  label="Sigla"
                  defaultValue={sigla}
                  maxRows={10}
                  onChange={(e) => setSigla(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormControlLabel
                  style={tamanhoForm}
                  id="preCadastro"
                  label="Exige pré-cadastro para realizar pagamento online"
                  control={
                    <Checkbox
                      disabled={disabled}
                      defaultChecked={precadastro}
                      onChange={(e) => handleChange(e)}
                    />
                  }
                />
                <TextField
                  disabled={disabled}
                  id="status"
                  select
                  required
                  label="Status"
                  style={tamanhoForm}
                  defaultValue={status}
                  onChange={handleChangeStatus}
                >
                  {statusOption.map((status) => (
                    <MenuItem key={status.key} value={status.value}>
                      {status.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item md={6}>
                <FormControlLabel
                  label="Checkout Interno"
                  control={
                    <Checkbox
                      disabled={disabled}
                      defaultChecked={interno}
                      onChange={(e) => handleChangeInterno(e)}
                    />
                  }
                />
                <FormControlLabel
                  label="Checkout Externo"
                  control={
                    <Checkbox
                      disabled={disabled}
                      defaultChecked={externo}
                      onChange={(e) => handleChangeExterno(e)}
                    />
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-end" spacing={3}>
          {disabled ? (
            <>
              <Button onClick={() => cancelar()}>Voltar</Button>
              <Button
                onClick={() => setDisabled(false)}
                color="primary"
                autoFocus
              >
                Editar
              </Button>
            </>
          ) : (
            <>
              <Button onClick={() => cancelar()}>Cancelar</Button>
              <Button onClick={() => confirma()} color="primary" autoFocus>
                Confirmar
              </Button>
            </>
          )}
        </Grid>
        <ModalConfirm
          open={controllerConfirm}
          onClose={validateConfirm}
          content={mensagem}
        />
        <Alert
          open={validation !== null}
          Close={() => setValidation(null)}
          severity="warning"
          message={validation}
        />
      </Box>
    </Dialog>
  );
}

export default ModalCadastroEdicao;
